import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import type { ChartView } from 'echarts/lib/echarts.all';
import RelationshipDiagram from './RelationshipDiagramSeries';
import RelationshipDiagramLayoutFunc from './RelationshipDiagramLayout';
import RelationshipDiagramView from './RelationshipDiagramView';
import { installRelationshipDiagramAction } from './RelationshipDiagramAction';

export function install(registers: EChartsExtensionInstallRegisters) {
  installRelationshipDiagramAction(registers);

  registers.registerSeriesModel(RelationshipDiagram);
  registers.registerChartView(RelationshipDiagramView as unknown as typeof ChartView);
  registers.registerLayout(RelationshipDiagramLayoutFunc);
}
